<div class="container is-grid-container">
    <ot-grid-section-header title="Privacy Notice" [hideFilterButton]="true">
    </ot-grid-section-header>

    <div class="ot-privacy-notice-language-dropdown-container"></div>
    <div id="otnotice-930a2044-08fd-4cb9-9e2f-0bd9662de408" class="otnotice is-scrollable"></div>
</div>
